module.exports = __webpack_public_path__ + "media/application/images/2022/magazine-5084cd565b56316697e41c0b443c08d1.png";